module.exports = "1. 这是说明信息\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/specTracker/specTracker-26.txt
// module id = V95y
// module chunks = 2